<div [class]="isDocumentSigned ? '' : ''" [class.show]="!isChecked"></div>

<div *ngIf="isEstampPending" class="estamp-pending-overlay">
  <div class="estamp-pending-card">
    <div class="estamp-pending-accent"></div>
    <img src="../../assets/img/new-logo.png" class="estamp-pending-logo" alt="Doqfy" />
    <div class="estamp-pending-spinner">
      <span></span>
      <span></span>
    </div>
    <h5 class="estamp-pending-title">Document in Progress</h5>
  </div>
</div>

<div *ngIf="!isDocumentSigned && !isEstampPending" class="bcg_esign">
    <div class="sign-topbar">
      <div class="sign-topbar-brand">
        <img src="../../assets/img/new-logo.png" class="sign-topbar-logo" />
        <div class="session-timer" [class.session-timer-warning]="sessionTimeLeft <= 60">
          <i class="pi pi-clock"></i>
          <span class="session-timer-label">Session expires in</span>
          <span class="session-timer-value">{{ sessionTimerDisplay }}</span>
        </div>
      </div>
      <div *ngIf="showSign" class="sign-topbar-pager">
        <input
          class="pager-input"
          [(ngModel)]="pageNo"
          type="number"
          [min]="1"
          [max]="numPdfPages"
        />
        <button class="pager-go-btn" (click)="pageChange(pageNo)">Go</button>
        <span class="pager-info">{{ numPdfPages }} pages</span>
      </div>
    </div>

    <p-dialog
      [(visible)]="displayConsentModal"
      [modal]="true"
      [closable]="false"
      [draggable]="false"
      [resizable]="false"
      [showHeader]="false"
      styleClass="consent-modal"
      [style]="{ width: '500px', maxWidth: '90vw' }"
    >
      <div [ngStyle]="{ zoom: showSign ? '1' : '0.8' }" class="card card_outLine p-3">

        <!-- Consent paragraph -->
        <p class="r1s_small mb-3">{{ 'CONSENT.TEXT' | translate }}</p>

        <!-- Checkbox row + language dropdown on same line -->
        <div class="d-flex align-items-center justify-content-between gap-2 mb-1">
          <div class="d-flex align-items-start gap-2">
            <input
              type="checkbox"
              (change)="onCheckboxChange($event)"
              [class.highlighted]="!isChecked && signerData.length > 0"
              [class.blinking]="!isChecked"
              class="form-check-input mt-1 me-1"
              [disabled]="signerData.length < 1"
            />
            <span class="r1s_small">{{ 'CONSENT.CHECKBOX_LABEL' | translate }}</span>
          </div>
          <app-dropdown
            class="flex-shrink-0 consent-language-dropdown"
            style="font-size: 0.75rem;"
            [options]="consentLanguages"
            optionLabel="label"
            optionValue="code"
            [sort]="false"
            [(ngModel)]="selectedConsentLang"
            appendTo="body"
            panelStyleClass="esign-consent-dropdown-panel"
            (onChange)="translate.use(selectedConsentLang)"
          ></app-dropdown>
        </div>

        <!-- Helper text -->
        <div class="mt-1" style="font-size: 0.72rem; color: #6c757d;">
          ({{ 'CONSENT.HELPER_TEXT' | translate }})
        </div>

      </div>
    </p-dialog>

    <ng-template #geoFencingModal let-modal>
      <div class="modal-content geo-fencing-specific">
        <div class="modal-body text-center p-4">
          <div class="mb-4">
            <i class="fas fa-globe-americas fa-3x text-danger"></i>
          </div>
          <h5 class="mb-3 font-weight-bold">Access Restricted</h5>
          <p class="text-muted mb-3">
            You're protected by Doqfy's security. Document signing is not
            available from your current location.
          </p>
          <div class="alert alert-light border small mb-4">
            <div class="d-flex justify-content-between">
              <span class="text-muted">Detected Location:</span>
              <span class="font-weight-bold">{{
                geoFencingData?.country
              }}</span>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <span class="text-muted">IP Address:</span>
              <span class="font-weight-bold">{{
                geoFencingData?.ip_address
              }}</span>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary btn-sm-block"
            (click)="modal.close('close')"
          >
            Acknowledge
          </button>
        </div>
      </div>
    </ng-template>

    <div class="row mt-2 esign-content-row">
      <div class="col-lg-8 col-sm-12 col-md-8 esign-scroll-pane" #scrollPane>
        <!-- Virtualized: only pages near the viewport (plus a buffer) are
             actually rendered to canvas at any moment, so every assigned
             position is still reachable by scrolling without mounting all
             pages of a large (2000-4000+) document at once. -->
        <app-pdf-virtual-viewer
          #pdfViewer
          [pdfData]="pdfUrl"
          [scrollRoot]="scrollPaneRef?.nativeElement"
          [overlayPages]="overlayPages"
          (docLoaded)="onDocLoaded($event)"
          (pageRendered)="onPageRendered($event)"
        >
          <ng-template let-pageNum>
            <ng-container
              *ngFor="let item of positionDetails?.[pageNum] || []"
            >
              <div
                class="custom_button_1"
                [ngClass]="{
                  'example-box': !signImage,
                  'example-box_sign': signImage,
                  'sign-box-blink': !signImage,
                  'authorized-frame-signed': signImage && signatoryDetails?.is_authorised && signatoryDetails?.authorised_for
                }"
                [style.transform]="
                  signImage && signatoryDetails?.is_authorised && signatoryDetails?.authorised_for
                    ? getSignedAuthorisedBoxPosition(item, pageNum)
                    : getPosition(item, pageNum)
                "
                [style.width.px]="
                  signImage && signatoryDetails?.is_authorised && signatoryDetails?.authorised_for
                    ? null
                    : getBoxSizePx(item).width
                "
                [style.height.px]="
                  signImage && signatoryDetails?.is_authorised && signatoryDetails?.authorised_for
                    ? null
                    : getBoxSizePx(item).height
                "
                [title]="signImage ? 'Click to change your signature' : 'Click to sign'"
                (click)="onSignatureBoxClick()"
              >
                <ng-container *ngIf="!signImage">
                  <i class="pi pi-pencil"></i>
                  <span>Signature Area</span>
                </ng-container>
                <img *ngIf="signImage" [src]="signImage" class="sign-box-preview-img" />
              </div>

              <!-- Authorised signatory, before signing only: labels placed
                   above/below the unchanged signature box. Once signed, the
                   composited image itself carries "For"/"Authorised
                   Signatory" (see getCodedImage()), so these are hidden to
                   avoid showing the frame text twice. -->
              <ng-container *ngIf="!signImage && signatoryDetails?.is_authorised && signatoryDetails?.authorised_for">
                <div
                  class="authorized-frame-label authorized-frame-label-floating"
                  [style.transform]="getAuthorisedLabelPosition(item, pageNum, 'top')"
                  [style.min-width.px]="getBoxSizePx(item).width"
                >For {{ signatoryDetails.authorised_for }}</div>
                <div
                  class="authorized-frame-label authorized-frame-label-floating"
                  [style.transform]="getAuthorisedLabelPosition(item, pageNum, 'bottom')"
                  [style.min-width.px]="getBoxSizePx(item).width"
                >Authorised Signatory</div>
              </ng-container>
            </ng-container>
          </ng-template>
        </app-pdf-virtual-viewer>
      </div>

      <div class="col-lg-4 col-sm-12 col-md-12 esign-scroll-pane">
        <div class="card card_outLine" style="position: relative; padding: 0">
          <div *ngIf="webcamImage">
            <div class="card-header title_five">
              <span class="title_five">Signer Image</span>
            </div>
            <div class="card-body">
              <div
                style="
                  justify-content: center;
                  align-items: center;
                  display: flex;
                "
              >
                <div>
                  <img
                    class="clickable"
                    [src]="webcamImage"
                    height="150"
                    width="200"
                  />
                </div>
                <div class="ms-4">
                  <p-button
                    label="Retake"
                    styleClass="p-button-sm-outline"
                    (click)="reTakeImage(userImage)"
                  ></p-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card_outLine" style="position: relative; padding: 0">
          <div class="card-header title_five">Signature Details</div>
          <div class="card-body">
            <div class="row mt-1">
              <div class="row">
                <div class="col-6">
                  <span class="r1"
                    >Order ID:<span class="r1s">{{ orderId }}</span></span
                  ><br />
                  <span class="r1"
                    >Name:<span class="r1s">{{
                      signatoryDetails?.name
                    }}</span></span
                  ><br />
                </div>
                <div class="col-6">
                  <span class="r1"
                    >Email:<span class="r1s">{{
                      signatoryDetails?.email
                    }}</span></span
                  ><br />
                  <span class="r1"
                    >Contact:<span class="r1s">{{
                      signatoryDetails.contact_number
                    }}</span></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card card_outLine" style="position: relative; padding: 0">
          <div class="card-header title_five">Summary</div>
          <div class="card-body">
            <div class="row mt-1">
              <div class="mt-3">
                <p class="r1s">
                  &#9658; The document will be sent to your email upon
                  completion by all signers.
                </p>
              </div>
              <div *ngIf="totalSignaturePositions > 0" class="mt-3">
                <p class="r1s">
                  &#9658; {{ totalSignaturePositions }} signature position{{
                    totalSignaturePositions === 1 ? "" : "s"
                  }}
                  assigned to you.
                </p>
              </div>
              <div class="mt-3">
                <p
                  *ngIf="signatoryDetails.signatory_sequence === 1"
                  class="r1s"
                >
                  &#9658; Your are the first one to open the Document.
                </p>
              </div>
              <div *ngIf="zeroSigners.length != 0" class="r1s">
                <ng-container
                  *ngFor="let signer of zeroSigners; let last = last"
                >
                  <span>
                    &#9658; E-sign link has been sent to
                    <span class="r1 ms-2">{{ signer.name }}</span
                    >{{ !last ? " ," : " ." }}<br
                  /></span>
                </ng-container>
              </div>
              <div *ngIf="beforeSigners.length != 0">
                <ng-container
                  *ngFor="let signer of beforeSigners; let last = last"
                >
                  <span class="r1s"
                    >&#9658; E-sign link has been sent to and Signed by
                    <span class="r1 ms-2">{{ signer.name }}</span
                    >. <br
                  /></span>
                </ng-container>
              </div>
              <div *ngIf="completedSigners.length != 0" class="r1s">
                <ng-container
                  *ngFor="let signer of completedSigners; let last = last"
                >
                  <span>
                    &#9658; Document has been Signed by
                    <span class="r1 ms-2">{{ signer.name }}</span
                    >.<br
                  /></span>
                </ng-container>
              </div>
              <div *ngIf="afterSigners.length != 0" class="r1s">
                <span class="r1 mt-4"> After your signing is Completed</span
                ><br />
                <ng-container
                  *ngFor="let signer of afterSigners; let last = last"
                >
                  <span>
                    &#9658; E-sign link needs to be send to
                    <span class="r1 ms-2">{{ signer.name }}</span
                    >.<br
                  /></span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="card card_outLine">
          <div *ngIf="!signImage" class="action-card-body">
            <p class="r1s mb-0">
              &#9658; Click any signature position on the document to sign.
            </p>
          </div>
          <div *ngIf="signImage" class="action-card-body" style="display: flex; align-items: center; gap: 0.75rem;">
            <img
              [src]="signImage"
              style="height: 60px; width: 100px; object-fit: contain; border: 1px solid #ede8f5; border-radius: 4px;"
            />
            <p class="r1s mb-0">
              &#9658; Click any signature position on the document to change it.
            </p>
          </div>
        </div>
        <div *ngIf="!webcamImage && enableCaptureImage" class="card card_outLine">
          <div class="card-header">Capture Image</div>
          <div class="card-body capture-section">
            <div class="capture-icon">
              <i class="pi pi-camera"></i>
            </div>
            <span class="capture-title">Take a selfie</span>
            <span class="capture-desc">Required for identity verification</span>
            <button class="sign-panel-btn" (click)="loadCam(userImage)">
              <i class="pi pi-camera me-2"></i> Open Camera
            </button>
          </div>
        </div>
        <div class="card card_outLine sign-finish-card">
          <div class="card-body">
            <div class="desc mb-2">
              **Others will be notified upon signing is Completed.
            </div>
            <p-button
              label="Finish"
              [disabled]="!isChecked || !isSignatureValid"
              (onClick)="SubmitSign()"
              styleClass="p-button-sm-outline w-100"
            ></p-button>
            <div *ngIf="!signImage" class="finish-error-msg sign-box-blink mt-2">
              <i class="pi pi-exclamation-triangle me-1"></i>Click on the
              signature box on the document above to add your signature.
            </div>
            <div *ngIf="!isSignatureValid" class="finish-error-msg mt-2">
              Complete all {{ totalSignaturePositions }} signature position{{
                totalSignaturePositions === 1 ? "" : "s"
              }}
              to enable Finish.
            </div>
            <div *ngIf="!isSignatureValid" class="finish-error-msg mt-2">
              Click on Signature Area to sign the document
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div
  *ngIf="isDocumentSigned && !isEstampPending"
  class="bcg_esign"
  style="justify-content: center; align-items: center; display: flex"
>
  <div class="card card_outLine">
    <div style="padding: 3rem 5rem">
      <img
        *ngIf="signatoryDetails.status === 'COMPLETED'"
        src="/assets/img/animation-crop.gif"
        class="sign-animation"
        alt="animation"
      />
      <div style="display: flex; justify-content: center; align-items: center">
        <img
          class="clickable"
          src="../../../assets/img/new-logo.png"
          height="60"
        />
      </div>

      <div
        *ngIf="signatoryDetails.status === 'COMPLETED'"
        class="my-4"
        style="display: flex; justify-content: center"
      >
        <img src="../../../assets/img/sign-completed.png" height="60" />
      </div>

      <div
        *ngIf="
          signatoryDetails.status === 'CANCELLED' ||
          signatoryDetails.status === 'EXPIRED'
        "
        class="my-3"
        style="display: flex; justify-content: center"
      >
        <img src="../../../assets/img/sign-cancelled.png" height="200" />
      </div>

      <div
        *ngIf="signatoryDetails.status === 'COMPLETED'"
        class="action-buttons mt-4"
      >
        <button
          class="action-btn email-btn"
          (click)="shareToEmail()"
          [disabled]="isEmailButtonDisabled"
          [class.disabled]="isEmailButtonDisabled"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
            ></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <span *ngIf="!isEmailButtonDisabled">Email to me</span>
          <span *ngIf="isEmailButtonDisabled"
            >Wait {{ emailCooldownTime }}s</span
          >
        </button>

        <button class="action-btn print-btn" (click)="printDocument()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path
              d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"
            ></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          Print
        </button>

        <button class="action-btn download-btn" (click)="downloadDocument()">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
          Download
        </button>
      </div>

      <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="py-2 mt-3">
        <h4
          class="title_five"
          style="
            font-size: 16px;
            display: flex;
            justify-content: center;
            text-align: center;
            top: 0.8rem;
            position: relative;
          "
        >
          Document Signed Successfully
        </h4>
      </div>

      <div *ngIf="signatoryDetails.status === 'CANCELLED'" class="p-2">
        <h4 class="title_five" style="display: flex; justify-content: center">
          The Signature is Cancelled.
        </h4>
      </div>
      <div *ngIf="signatoryDetails.status === 'EXPIRED'" class="p-2">
        <h4 class="title_five" style="display: flex; justify-content: center">
          The Signature is Expired.
        </h4>
      </div>
      <div *ngIf="signatoryDetails.status === 'COMPLETED'" class="mt-3">
        <h4 class="title_five home-page-link">
          <a href=" ">Go to the Doqfy login page</a>
        </h4>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="signModel"
  tabindex="-1"
  aria-labelledby="signModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="padding: 12px 15px">
        <h4 class="title_five" id="modal-basic-title">Choose Your Signature</h4>
        <button
          type="button"
          class="btn-close"
          style="font-size: 0.6rem"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body"
        style="
          background-color: #f3eeee;
          height: 100%;
          padding: 10px;
          border-radius: 6px;
        "
      >
        <div class="form_outline_model">
          <div class="row">
            <div class="col-lg-5 col-sm-5 col-md-5">
              <span class="form_field">Name and Signature</span
              ><span class="color_red">*</span>
              <input
                class="form-control edit_input"
                [class.saved-disabled]="signOption === 'saved'"
                style="
                  height: 4.5vh;
                  margin: 0.3rem 0rem;
                  font-size: 0.8rem;
                  background-color: #f3eeee;
                "
                [(ngModel)]="signatoryName"
                (input)="onNameChange()"
                (ngModelChange)="onNameChange()"
                placeholder="Enter Name"
                pInputText
                type="text"
                maxlength="50"
                [disabled]="signOption === 'saved'"
              />
            </div>
          </div>
        </div>
        <div class="form_outline_model">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active title_five_model"
                style="color: black"
                id="select-tab"
                (click)="selectSignatureTab('select')"
                data-bs-toggle="tab"
                data-bs-target="#select"
                type="button"
                role="tab"
                aria-controls="select"
                aria-selected="true"
              >
                Select Style
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link title_five_model"
                style="color: black"
                id="draw-tab"
                data-bs-toggle="tab"
                (click)="selectSignatureTab('draw')"
                data-bs-target="#draw"
                type="button"
                role="tab"
                aria-controls="draw"
                aria-selected="false"
              >
                Draw
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link title_five_model"
                style="color: black"
                id="upload-tab"
                data-bs-toggle="tab"
                (click)="selectSignatureTab('upload')"
                data-bs-target="#upload"
                type="button"
                role="tab"
                aria-controls="upload"
                aria-selected="false"
              >
                Upload
              </button>
            </li>
            <li
              class="nav-item"
              role="presentation"
              *ngIf="savedSignature && savedSignatureName"
            >
              <button
                class="nav-link title_five_model"
                style="color: black"
                id="saved-tab"
                (click)="selectSavedSignatureTab()"
                data-bs-toggle="tab"
                data-bs-target="#saved"
                type="button"
                role="tab"
                aria-controls="saved"
                aria-selected="false"
              >
                Saved Signature
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="select"
              role="tabpanel"
              aria-labelledby="select-tab"
            >
              <div
                class="flex_row mt-2"
                style="
                  display: flex;
                  justify-content: space-around;
                  padding: 0.5rem 0rem;
                "
              >
                <div class="col-6 col-md-3 p-field-radiobutton radio_btn mb-2">
                  <input
                    type="radio"
                    id="signInt"
                    name="signPlace"
                    checked
                    (click)="selectTextSign('Name', 'Brush Script MT')"
                    class="me-1"
                  />
                  <label
                    class="me-1 ms-1 signature-label"
                    style="
                      font:
                        italic 18px &quot;Brush Script MT&quot;,
                        cursive;
                    "
                    for="signInt"
                    >{{ signatoryName }}</label
                  >
                </div>
                <div class="col-6 col-md-3 p-field-radiobutton radio_btn mb-2">
                  <input
                    type="radio"
                    id="signName"
                    (click)="selectTextSign('Name', 'Comic Sans MS')"
                    name="signPlace"
                    class="me-1"
                  />
                  <label
                    class="me-1 ms-1 signature-label"
                    style="
                      font:
                        italic 18px &quot;Comic Sans MS&quot;,
                        cursive;
                    "
                    for="signName"
                    >{{ signatoryName }}</label
                  >
                </div>
                <div class="col-6 col-md-3 p-field-radiobutton radio_btn mb-2">
                  <input
                    type="radio"
                    id="signCourier"
                    name="signPlace"
                    (click)="selectTextSign('Name', 'Courier New')"
                    class="me-1"
                  />
                  <label
                    class="me-1 ms-1 signature-label"
                    style="
                      font:
                        italic 18px &quot;Courier New&quot;,
                        monospace;
                    "
                    for="signCourier"
                    >{{ signatoryName }}</label
                  >
                </div>
                <div class="col-6 col-md-3 p-field-radiobutton radio_btn mb-2">
                  <input
                    type="radio"
                    id="signImpact"
                    name="signPlace"
                    (click)="selectTextSign('Name', 'Impact')"
                    class="me-1"
                  />
                  <label
                    class="me-1 ms-1 signature-label"
                    style="
                      font:
                        italic 16px Impact,
                        sans-serif;
                    "
                    for="signImpact"
                    >{{ signatoryName }}</label
                  >
                </div>
              </div>
              <div class="flex_row">
                <div class="col-6" style="height: 8rem">
                  <div *ngIf="imageStyle" class="mt-2">
                    <div class="signature-preview-container">
                      <img
                        [src]="imageStyle"
                        class="signature-preview-image signature-fade-in"
                        alt="Signature Preview"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="row mt-5">
                    <div class="col-5">
                      <span class="form_field" style="margin-left: 3rem"
                        >Select Font</span
                      ><span class="color_red">*</span>
                    </div>

                    <div class="col-7 form_inputFields">
                      <app-dropdown
                        class="custom-dropdown"
                        [options]="signStyle"
                        [(ngModel)]="selectedStyle"
                        (onChange)="getStyleType()"
                        placeholder="Select Font"
                        optionLabel="name"
                        optionValue="code"
                        [autoDisplayFirst]="false"
                      >
                        <ng-template let-option pTemplate="item">
                          <span
                            [style]="{ font: option.code, 'font-size': '14px' }"
                            >{{ option.name }}</span
                          >
                        </ng-template>
                      </app-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="draw"
              role="tabpanel"
              aria-labelledby="draw-tab"
            >
              <div style="text-align: center; margin-top: 30px">
                <canvas
                  #signPadCanvas
                  style="border: 1px solid #f3eeee; background-color: white"
                  width="750"
                  height="150"
                ></canvas>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="upload"
              role="tabpanel"
              aria-labelledby="upload-tab"
            >
              <div class="row mt-4">
                <span class="form_field">Preview</span>
                <div
                  class="col-lg-6 col-sm-6 col-md-6 mt-2 ms-2 upload-img"
                  style="border: 1px solid #f3eeee; background-color: white"
                >
                  <img
                    src="{{ pdfSource }}"
                    style="
                      max-width: 100%;
                      height: auto;
                      background-color: white;
                    "
                  />
                </div>
                <div class="col-lg-4 col-sm-4 col-md-4 m-4">
                  <span
                    class="form_field"
                    style="margin-bottom: 10px; display: inline-block"
                    >Upload Sign image for Signature</span
                  ><span class="color_red">*</span>
                  <input
                    [hidden]="true"
                    type="file"
                    id="upload_file"
                    accept="image/jpeg, image/jpg, image/png, image/bmp"
                    (change)="onFileChange($event)"
                    #fileInput
                    #upload_file
                  />

                  <p-button
                    label="{{ fileName }}"
                    (click)="fileInput.click()"
                    class="ms-2 mt-2"
                    styleClass="p-button-sm-outline"
                  ></p-button>
                </div>
                <span style="font-size: 0.6rem; margin: 10px 0px"
                  ><span class="color_red">*</span>Dimensions 4.5 cm x 3cm
                  (preferred) Size of file should be between ( 10KB – 10MB)
                  Ensure that the size of the scanned image is not more than
                  10MB</span
                >
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="saved"
              role="tabpanel"
              aria-labelledby="saved-tab"
            >
              <div class="row mt-4" style="justify-content: center">
                <div class="col-6" style="height: 8rem">
                  <div class="signature-preview-container">
                    <img
                      [src]="'data:image/png;base64,' + savedSignature"
                      class="signature-preview-image signature-fade-in"
                      alt="Saved Signature Preview"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-10 ms-1 form_field_content">
              By selecting "Sign," I acknowledge and agree that the electronic
              representation of my signature will hold the same legal weight and
              significance as a traditional pen-and-paper signature for all
              purposes when used on documents, including legally binding
              contracts.
            </div>
          </div>

          <div class="row me-4 mb-4">
            <div class="text-left ms-1 mt-2 save-btn" style="padding: 0">
              <p-button
                label="Save"
                data-bs-dismiss="modal"
                (click)="saveImage(userImage)"
                class="ms-2"
                styleClass="p-button-sm-outline"
                [disabled]="
                  !signatoryDetails.name || signatoryDetails.name.trim() === ''
                "
              ></p-button>
              <p-button
                *ngIf="signOption != 'select' && signOption != 'saved'"
                label="Clear"
                (click)="clearImage()"
                class="ms-2"
                styleClass="p-button-sm"
              ></p-button>
              <p-button
                label="Cancel"
                data-bs-dismiss="modal"
                class="ms-2"
                styleClass="p-button-sm"
              ></p-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #signatureWarning let-modal>
  <div class="modal-header custom-header text-white">
    <h4 class="modal-title mb-0">Signature Error</h4>
  </div>

  <div class="modal-body">
    <div class="d-flex align-items-center mb-2 text-danger">
      <strong>Signature is blank.</strong>
    </div>
    <p class="mb-1">Please sign the document before submitting.</p>
    <p class="mb-0">This screen will now refresh to allow you to try again.</p>
  </div>

  <div class="modal-footer">
    <button class="btn custom-btn" (click)="onSignatureWarningOk(modal)">
      <i class="pi pi-refresh me-1"></i> Okay
    </button>
  </div>
</ng-template>

<ng-template #userImage let-modal>
  <div [ngStyle]="{ zoom: showSign ? '1' : '0.8' }" class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Capture Image</h4>
  </div>

  <div class="modal-content" *ngIf="!isSignFailed">
    <div
      class="modal-body"
      style="background-color: #f3eeee; height: 100%; padding: 5px"
    >
      <app-kyc-details
        [showWebcam]="showWebcam"
        (initError)="handleInitError($event)"
        (pictureTaken)="handleImage($event)"
         [orderId]="orderId"
      ></app-kyc-details>
    </div>
  </div>
</ng-template>

<ng-template #otpScreen let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="text-center" style="zoom: 80%">
        <div *ngIf="!sendOtpLink && !isSignFailed" class="form-signin">
          <div class="radius_border text-left">
            <img
              alt=""
              class="mb-4"
              style="height: 3rem"
              src="../../assets/img/new-logo.png"
            />
            <div class="container">
              <div>
                A Otp will be sent to {{ signatoryDetails?.email }}
                <span *ngIf="signatoryDetails?.contact_number">
                  and {{ signatoryDetails?.contact_number }}
                </span>
                for verification.
              </div>
              <div class="mt-4">
                <button
                  (click)="resendOtp()"
                  class="btn btn-primary ms-2"
                  style="background-color: rgb(74, 11, 119)"
                >
                  Send OTP
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="sendOtpLink" class="form-signin">
          <div class="radius_border text-left">
            <img
              alt=""
              class="mb-4"
              style="height: 3rem"
              src="../../assets/img/new-logo.png"
            />
            <div class="container">
              <div>
                A 6-digit code has been sent to {{ signatoryDetails?.email }}.
                <span *ngIf="signatoryDetails?.contact_number">
                  and {{ signatoryDetails?.contact_number }} </span
                >. Enter the code to Proceed.
              </div>

              <div class="tab-content mt-4" id="pills-tabContent">
                <div>
                  <div class="otp_section">
                    <ng-otp-input
                      #ngOtpInput
                      (onInputChange)="onOtpChange($event)"
                      *ngIf="showOtpComponent"
                      [config]="config"
                    ></ng-otp-input>
                  </div>

                  <div class="row">
                    <div class="mt-3">
                      <button
                        [disabled]="enableOtp"
                        (click)="otpOnSubmit()"
                        class="btn btn-primary"
                        style="background-color: rgb(74, 11, 119)"
                      >
                        Submit
                      </button>
                      <button
                        *ngIf="timeLeft === 0"
                        (click)="resendOtp()"
                        class="btn btn-primary ms-2"
                        style="background-color: rgb(74, 11, 119)"
                      >
                        Resend OTP
                      </button>
                      <div class="font-weight-bold mt-3 cursor">
                        <span class="resend-otp">Resend OTP </span>
                        <span class="resend-otp-timer">
                          in {{ timeLeft }} Sec</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
